import React, { useState } from 'react';
import Header from './navbar.js';
import {Link} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../css/resetPassword.css';
import { useDispatch , useSelector } from 'react-redux';
import { changePassword } from '../store/Slices/authSlice.js';
import toast , {Toaster} from 'react-hot-toast';

const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
       
    };
    
    const handleEmailBlur = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email) && email.length > 0) {
            setError('Invalid email format');
        } else {
            setError('');
        }
    };

    const handleOldPasswordChange = (e) => {
        setOldPassword(e.target.value);
    };

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            "email" : email, 
            "old_password" : oldPassword,
            "new_password" : newPassword
        };
        dispatch(changePassword(data)).then((response) => {
            if(response?.payload?.message === "success"){
                toast.success('Password changed successfully');
                navigate('/');
            }
            else {
                setError(response?.error?.message || 'Something went wrong');
            }
        });
    };

    return (
        <div>
            <Header />
            <Toaster position="top-center" reverseOrder={false}></Toaster>
            <div className="reset-password-container">
                <form onSubmit={handleSubmit} className="reset-password-box">
                    <h1 className="reset-password-title">Reset Password</h1>
                    <div>
                        <label>Email:</label>
                        <input 
                            type="email" 
                            value={email} 
                            onChange={handleEmailChange} 
                            onBlur={handleEmailBlur}
                            placeholder="Example@orange.com" 
                        />
                        {error && <span>{error}</span>}
                    </div>
                    <div className="reset-password-row">
                        <div>
                            <label>Old Password:</label>
                            <input
                                type="password"
                                value={oldPassword}
                                onChange={handleOldPasswordChange}
                                placeholder="Old password"
                            />
                        </div>
                        <div>
                            <label>New Password:</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={handleNewPasswordChange}
                                placeholder="New password"
                            />
                        </div>
                    </div>
                    <div className="login-link">
                        <Link to="/">Back to Login</Link>
                    </div>
                    <button type="submit">Reset Password</button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;